import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { t } from '@lingui/macro';
import { Button, Tooltip } from '@decisiv/ui-components';
import Link from '@decisiv/iconix/lib/components/Link';
import ClipboardCheck from '@decisiv/iconix/lib/components/ClipboardCheck';

// A double click fires two clicks first, so the slug URL is copied and then
// overwritten by the ID URL; the clipboard ends up right either way.
export default function CopyUrlButton({ basePath, id, slug = '' }) {
  const [copied, setCopied] = useState(null);
  const resetTimer = useRef();

  useEffect(() => () => clearTimeout(resetTimer.current), []);

  const copy = (value, kind) => {
    if (!navigator.clipboard?.writeText) return;

    navigator.clipboard
      .writeText(value)
      .then(() => {
        setCopied(kind);
        clearTimeout(resetTimer.current);
        resetTimer.current = setTimeout(() => setCopied(null), 1500);
      })
      .catch(() => {});
  };

  const urlFor = (identifier) =>
    `${window.location.origin}${basePath}/${identifier}`;

  const labels = {
    url: t`Copied URL!`,
    id: t`Copied URL by ID!`,
  };
  const label =
    labels[copied] || t`Click: copy URL · Double-click: copy URL by ID`;

  return (
    <Tooltip
      placement="right"
      target={
        <div>
          <Button
            aria-label={label}
            icon={copied ? ClipboardCheck : Link}
            variant="ghost"
            size="small"
            onClick={() => copy(urlFor(slug || id), 'url')}
            onDoubleClick={() => copy(urlFor(id), 'id')}
          />
        </div>
      }
    >
      {label}
    </Tooltip>
  );
}

CopyUrlButton.propTypes = {
  basePath: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  slug: PropTypes.string,
};
